var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.19,24.84C81,19,78.26,17,77.09,16.3A43.63,43.63,0,0,0,22.17,84.11a43.36,43.36,0,0,0,26.18,9.77,2.9,2.9,0,0,0,.71.1,3.38,3.38,0,0,0,.63-.07h.05a3.38,3.38,0,0,0,.63.07,3.24,3.24,0,0,0,.75-.11,43.6,43.6,0,0,0,34.07-69Zm-11-3.31c.38.24,2.51,1.74,6.16,6.82a37.45,37.45,0,0,1,6.93,19H69a66.15,66.15,0,0,0-11.71-33.9,37.53,37.53,0,0,1,16.26,7.72A1.69,1.69,0,0,0,74.15,21.53Zm-24.43,66C43,80.79,37.29,66,36.48,53.31H63C62.14,66,56.42,80.79,49.72,87.5ZM36.47,47.31c.71-12.36,5.7-25.15,13.25-33.84C57.26,22.16,62.26,34.94,63,47.31ZM20.58,26.52A37.36,37.36,0,0,1,42.14,13.44,66.21,66.21,0,0,0,30.45,47.31H12.25A37.47,37.47,0,0,1,20.58,26.52ZM12.27,53.31H30.46c.69,11.76,5.22,25.06,11.2,33.75A37.61,37.61,0,0,1,12.27,53.31ZM78.91,74.08a37.39,37.39,0,0,1-21.14,13c6-8.69,10.52-22,11.2-33.75H87.23A37.5,37.5,0,0,1,78.91,74.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.cd4e3cd80583cd47fc21975cb593d77b.svg";
export { ForwardRef as ReactComponent };